import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import '../ModalTransaccion/modalTransaccion.css'
import transaction from '../../assets/images/detalle_transaccion.svg';
class ModalTransaccion extends Component {
  render() {
    let { children, footer } = this.props;
    return (
      <Modal {...this.props} aria-labelledby="contained-modal-title-vcenter" centered

      >
        <Modal.Header className="p-0" closeButton>
          <img className="img-fluid"
            style={{ borderRadius: "14px" }}
            height={400} src={transaction} alt="imagenTransaction" />
        </Modal.Header>
        {children &&
          <Modal.Body className="p-0">
            {children}
          </Modal.Body>
        }
        {footer &&
          <Modal.Footer>
            {footer}
          </Modal.Footer>
        }

      </Modal>
    );
  }
}

export default ModalTransaccion;